// Changelog — handmatig bijgehouden overzicht van wijzigingen per datum.
// Nieuwste bovenaan. Wordt getoond onder Beheer › Changelog.
export const CHANGELOG = [
  {
    datum: '2026-07-27',
    wijzigingen: [
      'Recente wijzigingen: op de "Betreft"-waarde (project, buurt) klikken zoomt er nu naartoe, alsof je het in de zoekbalk had ingevuld. Gebruikersacties blijven gewone tekst.',
      'Aankondigingsbrief: de titel boven de plek is kort "Elektriciteitshuisjes". De adressen staan nu in de bijlage onder de legenda, genummerd in twee kolommen, en de nummers komen overeen met de genummerde placemarks op het kaartje erboven.',
    ],
  },
  {
    datum: '2026-07-26',
    wijzigingen: [
      'Aankondigingsbrief flink bijgewerkt: telefoonnummer (088 - 89 639 63) en e-mail van de omgevingsmanager bovenin, generatiedatum ingevuld, datum in de brief uitgeschreven (bv. "5 juni 2028"), titel klopt bij meerdere huisjes met de adressen ("nabij …") eronder, de zin over te vervangen stations valt weg als er geen zijn, "Zoek project" toont de buurtnaam, en het algemene telefoonnummer van de gemeente wordt automatisch ingevuld (per gemeente geverifieerd — meestal 14 + netnummer, soms een direct of 088-nummer).',
    ],
  },
  {
    datum: '2026-07-25',
    wijzigingen: [
      'Gemeente- en regiogrenzen sluiten nu naadloos aan op de buurten (afgeleid uit de buurten i.p.v. een aparte, grovere bron); geen springende randen of lege vakken meer tussen niveaus. Responses worden voortaan gecomprimeerd (gzip), wat de kaart sneller laadt.',
      'Meerdere stationslocaties mogen nu tegelijk op Akkoord staan; het akkoord zetten van de ene locatie haalt dat niet meer weg bij een andere. Welke locatie het wordt, blijft je aangeven met "Markeer als gekozen".',
      'Projectniveau: de stationslocatie ligt nu over de KLIC-kabels/leidingen heen in plaats van eronder.',
    ],
  },
  {
    datum: '2026-07-23',
    wijzigingen: [
      'De stip op buurtniveau kleurt nu meteen mee als je een locatie op akkoord/afgekeurd/vervallen zet, en volgt de daadwerkelijk gezette status (niet meer alleen die van de gekozen locatie).',
      '"Type werk"-keuzelijst opgeschoond: alleen stationsopgaven; MS-werk, tracéwerkzaamheden en lege waarden zijn eruit.',
    ],
  },
  {
    datum: '2026-07-22',
    wijzigingen: [
      'De inlognaam wordt nergens meer getoond; overal staat nu de naam van de gebruiker — in Gebruikersbeheer, Recente wijzigingen, Op- en aanmerkingen, de locatietijdlijn en het gebruikersmenu. Is voor-/achternaam nog niet ingevuld, dan wordt er een leesbare naam van de inlognaam gemaakt.',
      'Stationsstatus nog maar op één plek: de "Markeer voor akkoord"-knop per locatie. De losse status-dropdown op stationsniveau is verwijderd.',
      'Legenda op buurtniveau volgt nu die akkoordstatus: Akkoord, Afgekeurd, Vervallen en Nog te bepalen (Gereed, Onderzoek, Ntb. en Bestaand vervallen). Stip- en lijstkleur volgen mee.',
      'Legenda op projectniveau toont nu de KLIC-kleurcodering (welke kleur = welke kabel/leiding) in plaats van de status; ingekort tot alleen de thema’s die in de buurt voorkomen.',
      'Nieuw menu-item "Uitleg" onder de gebruikersknop: hoe je navigeert, hoe je de stip leest, stations plaatsen/verplaatsen/draaien, locatievarianten en akkoord, en wat je per buurt kunt doen.',
      'Rechtsklik terug van project- naar buurtniveau toont nu de buurtinformatie in het zijpaneel (bleef ten onrechte het station tonen).',
      'Onderscheid tussen een vervangend station (blauwe rand, het nieuwe station) en een te vervangen station (rode rand, het bestaande station dat verdwijnt). Met de knop "Te vervangen station koppelen" op buurtniveau leg je vast welk bestaand station vervangen wordt; er loopt dan een stippellijn tussen beide. Eén vervangend station mag er meerdere vervangen.',
      'De stip op buurtniveau toont nu twee dingen tegelijk: de vulling is de akkoordstatus (Vervallen is nu zwart i.p.v. grijs), de rand het soort werk — wit nieuw, grijs ombouw, blauw vervangend, rood te vervangen. De legenda toont beide, plus het bestaande station (grijs met witte ring).',
      'Het soort werk komt uit het veld "Type werk", dat nu zelf te wijzigen is in de stationszijbalk. Stationstype blijft daarmee puur het kastmodel.',
      'Ombouw krijgt op projectniveau grijze kringloop-pijlen en géén footprint meer: die werd uit een kastmodel gegenereerd en klopte nooit met het bestaande station. Verslepen blijft werken. Een vervangend station is wél nieuwbouw en houdt dus gewoon zijn huisje.',
    ],
  },
  {
    datum: '2026-07-18',
    wijzigingen: [
      'Nieuw geplaatst station (via + of ctrl-klik) is nu meteen versleepbaar op projectniveau.',
      'Buurt-infopaneel opgeschoond: Huisaansluitingen, Ranking en de Prognose-sectie verwijderd; Netstrategie en Start uitvoering gecentreerd.',
      'Bewonersbrief-bijlage: automatisch kaartje met atlas-achtergrond en groene (nieuw) / paarse (te vervangen) markers met witte kern, zoals Google My Maps.',
      'Changelog en Op- en aanmerkingen (issues/wensen) toegevoegd onder Beheer.',
    ],
  },
  {
    datum: '2026-07-17',
    wijzigingen: [
      'Bewonersbrief automatisch vullen (Word) + KML-placemarks per buurt, via de Bewonersbrieven-dropdown.',
      'Buurt-zijbalk: alles als dropdown (Stations, Belangentafels, KLIC, Bewonersbrieven, Rapportages).',
      'Betrokken ambtenaren: gekoppelde geregistreerde gebruikers verschijnen automatisch en vullen "Belangentafel starten" voor; compactere weergave (1 regel).',
    ],
  },
  {
    datum: '2026-07-13',
    wijzigingen: [
      'Recente wijzigingen: breder venster en paginering.',
      'Vluchtige-versie-drempel van 25 s naar 300 s (5 min).',
      'sheijdemann als enige/standaard beheerder.',
    ],
  },
  {
    datum: '2026-07-12',
    wijzigingen: [
      'Registratieformulier vereenvoudigd (e-mail = login; regio/gemeenten-multiselect).',
      'Gebruikersbeheer: voor-/achternaam apart en koppeling aan meerdere gemeenten/regio’s.',
      'Locatie-statusknop cyclet (akkoord / afgekeurd / vervallen); stip volgt de gekozen locatie.',
      'WMS-overlay "percelen met recht" als toggle op projectniveau.',
      'Belangentafels verwijderen met bevestiging.',
    ],
  },
  {
    datum: '2026-07-11',
    wijzigingen: [
      'Situatietekening (A3, 1:500) per locatie met knop in de tijdlijn.',
      'Transcriptie koppelt per besproken locatie; correcties per blok in de review.',
    ],
  },
];
